import alt from 'components/Dispatcher';

class PlaybackActions {
  constructor() {
    this.generateActions('play', 'pause', 'dialogMaskShown', 'dialogMaskHidden');
  }
}

export default alt.createActions(PlaybackActions);
